<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sl4GtY/tc-custom/9780312246020.jpg?1721057728821" alt="This image is the cover for the book 15 Biggest Lies in Politics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">15 Biggest Lies in Politics
      </h1>
      <p class="bookDescription body article font2">
        <p>In the world of politics, it's hard to separate the truth from the lies. In this strongly argued but nonpartisan book, Major Garrett and Timothy J. Penny draw on their combined decades of experience watching government work to illuminate the deceptions and delusions to which we as citizens are subjected every election season. Here are some of the lies: <br/><br/>Tax Cuts Are Good <br/>Social Security Is a Sacred Government Trust <br/>Medicare Works <br/>Money Buys Elections <br/>Republicans Believe in Smaller Government <br/>Democrats Are Compassionate</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Major Garrett, Tim J. Penny
      </h2>
      
      <p class="authorDescription body article"><P><B>Major Garrett</B> is the congressional correspondent for <I>U.S. News & World Report</I>. He has appeared on such television programs as <I>Hardball </I>with Chris Mathews, CNN's <I>Crossfire</I>, and <I>The Today Show</I>. <br><br>Former congressman <B>Timothy J. Penny</B>, now a senior fellow at the University of Minnesota's Humphrey Institute and policy chair of the budget watchdog group Concord Coalition, lives in Waseca, Minnesota. Their previous book was <I>Common Cents.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?494a9942